<template>
<div :class="$style.root">
  <el-form
    :model="value"
    :rules="formRules"
    :hide-required-asterisk="true"
    label-position="right"
    label-width="80px"
    :inline="true"
    :class="$style.form"
    ref="form">

    <el-form-item label="" prop="name" >
      <el-input
        v-model="value.name"
        readonly
        :class="$style.formName">
      </el-input>
    </el-form-item>
    <el-form-item label="下限" label-width="50px" prop="lowlimit">
      <el-input-number
        v-model="value.lowlimit"
        controls-position="right"
        :precision="1"
        :step="1"
        :min="0"
        :max="STAIR_MAX_LIMIT"
        @change="onLowLimitChange"
        :disabled="readonly || index === 0"
        :class="$style.formLowlimit">
      </el-input-number>
    </el-form-item>
    <el-form-item label="上限" label-width="50px" prop="uplimit">
      <el-input-number
        v-model="value.uplimit"
        controls-position="right"
        :precision="1"
        :step="1"
        :min="0"
        :max="STAIR_MAX_LIMIT"
        :disabled="readonly || isLast"
        :class="$style.formUplimit">
      </el-input-number>
    </el-form-item>

    <el-form-item label="阶梯类型" prop="stairtype">
      <el-radio-group v-model="value.stairtype" :disabled="readonly">
        <el-radio-button
          v-for="item in stairTypes"
          :key="item.id"
          @change="onStairTypeSwitch"
          :label="item.id">
          {{item.name}}
        </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="指定金额" prop="speprice">
      <el-input-number
        v-model="value.speprice"
        controls-position="right"
        :disabled="readonly || disabledFormItems['speprice']"
        :precision="1"
        :min="0"
        :max="100"
        :class="$style.formSpeprice">
      </el-input-number>
    </el-form-item>

    <el-form-item label="上浮比例" prop="speratio">
      <el-input-number
        v-model="value.speratio"
        controls-position="right"
        :precision="2"
        :step="0.1"
        :min="0"
        :max="10"
        :disabled="readonly || disabledFormItems['speratio']"
        :class="$style.formSperatio">
      </el-input-number>
    </el-form-item>
  </el-form>
</div>
</template>

<script>
import * as constants from '../../constants'

export default {

  props: {
    value: {
      type: Object
    },
    index: {
      type: Number
    },
    isLast: Boolean,
    readonly: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      STAIR_MAX_LIMIT: constants.STAIR_MAX_LIMIT,
      stairTypes: constants.STAIR_TYPES,

      form: {
        name: null,
        uplimit: 1,
        lowlimit: 0,
        stairtype: constants.STAIR_TYPES[0].id,
        speprice: null,
        speratio: null,
      },
      formRules: {
        // name: [
        //   { required: true, message: '请输入阶梯名称', trigger: 'blur' }
        // ],
        uplimit: [
          { validator: this.limitsValidator, trigger: 'change'}
        ],
        lowlimit: [
          { validator: this.limitsValidator, trigger: 'change'}
        ],
        speprice: [
          {validator: this.spepriceValidator, trigger: 'change'}
        ],
        speratio: [
          {validator: this.speratioValidator, trigger: 'change'}
        ],
      }
    }
  },
  computed: {
    disabledFormItems() {
      return {
        speprice: this.value.stairtype !== constants.STAIR_TYPE_FIXED,
        speratio: this.value.stairtype !== constants.STAIR_TYPE_RATIO
      }
    }
  },
  watch: {
    form(form) {
      this.$emit('input', form)
    },
    // for validator
    'value.uplimit'() {
      this.$refs.form.validateField('lowlimit')
    },
    'value.lowlimit'() {
      this.$refs.form.validateField('uplimit')
    }
  },
  created() {
    this.$bus.$on('STAIRSTEP_PRICE_LOWLIMIT_MODIFIED', data => {
      if(data.index - 1 === this.index) {
        this.$emit('input', Object.assign({}, this.value, {
          uplimit: data.value
        }))
      }
    })
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    limitsValidator(rule, value, callback) {
      if(this.value.uplimit > this.value.lowlimit && this.value.lowlimit >= 0) {
        callback()
      } else {
        callback(new Error('上限必须大于小限'))
      }
    },
    spepriceValidator: function(rule, value, callback) {
      if(this.value.stairtype === constants.STAIR_TYPE_FIXED && (value <= 0 || !value)) {
        callback(new Error('请输入金额'))
      } else {
        callback()
      }
    },
    speratioValidator: function(rule, value, callback) {
      if(this.value.stairtype === constants.STAIR_TYPE_RATIO && (value <= 0 || !value)) {
        callback(new Error('请输入上浮比例'))
      } else {
        callback()
      }
    },
    // 阶梯类型切换时清除禁用表单项的内容
    onStairTypeSwitch() {
      for(let formItemName in this.disabledFormItems) {
        if(this.disabledFormItems[formItemName]) {
          this.form[formItemName] = 0
        }
      }
    },
    // 因为编辑当前规则(肯定是最后一条)的 lowlimit 时,要级联更改上一条规则的 uplimit (确保连续), 所以要校验上一条规则的 uplimit 是否合法(uplimit > lowlimit)
    onLowLimitChange(val, oldVal) {
      let prevItem = this.$parent.value[this.index - 1]
      if(prevItem) {
        // 不合法, 恢复原值
        if(val <= prevItem.lowlimit) {
          this.$nextTick(() => {
            this.$emit('input', Object.assign({}, this.value, {
              lowlimit: oldVal
            }))
          })
        } else {
          this.$bus.$emit('STAIRSTEP_PRICE_LOWLIMIT_MODIFIED', {
            value: val,
            index: this.index
          })
        }
      }
    }
  }
}
</script>

<style lang="less" module>
.root, .form{
  display: inline-block;

  :global(.el-input-number .el-input.is-disabled .el-input__inner) {
    background-color: #fff;
  }
}
.form :global(.el-form-item:last-child) {
  margin-right: 0;
}
.formName{
  width: 110px;
}
.formUplimit{
  width: 120px;
}
.formLowlimit{
  width: 120px;
}
.formSpeprice{
  width: 100px;
}
.formSperatio{
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/sysmodule/waterfee/pricing/components/stairstep-price-item.vue